import React, { useState, useEffect, useMemo } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const MobileBackToProductsButton = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  // Función para verificar si el dispositivo es móvil
  const checkIsMobile = () => {
    const mobileBreakpoint = 768; // Ancho máximo para considerar como móvil
    setIsMobile(window.innerWidth <= mobileBreakpoint);
  };

  // Efecto para detectar cambios en el tamaño de la pantalla
  useEffect(() => {
    checkIsMobile(); // Verificar al montar el componente
    window.addEventListener('resize', checkIsMobile); // Escuchar cambios en el tamaño de la pantalla

    return () => {
      window.removeEventListener('resize', checkIsMobile); // Limpiar el listener al desmontar
    };
  }, []);

  // Memoizar el valor de isMobile para evitar re-renders innecesarios
  const memoizedIsMobile = useMemo(() => isMobile, [isMobile]);

  const handleRedirectToProducts = () => {
    navigate('/products'); // Redirige a la página de productos
  };

  // Si no es móvil, no renderizar el botón
  if (!memoizedIsMobile) {
    return null;
  }

  return (
    <div className="fixed top-20 right-4 z-50">
      <motion.button
        type="button"
        onClick={handleRedirectToProducts}
        className="bg-primary text-white p-3 rounded-full shadow-lg hover:bg-primary-dark transition-colors flex items-center justify-center relative"
        aria-label="Volver a productos"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        whileHover={{ scale: 1.1 }} // Animación al hacer hover
        whileTap={{ scale: 0.9 }} // Animación al hacer clic
      >
        <ArrowLeft size={24} /> {/* Ícono de flecha hacia la izquierda */}

        {/* Tooltip */}
        <AnimatePresence>
          {showTooltip && (
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 10 }}
              transition={{ type: 'spring', stiffness: 300, damping: 20 }}
              className="absolute -top-10 right-0 bg-gray-800 text-white text-sm px-3 py-1 rounded-lg whitespace-nowrap"
            >
              Volver a productos
            </motion.div>
          )}
        </AnimatePresence>
      </motion.button>
    </div>
  );
};

export default MobileBackToProductsButton;